export default "__VITE_ASSET__Of$KzOGK__"